import React, { Component } from 'react'
import propTypes from 'prop-types'
import { Checkbox, context, DropDownInput, i18n } from '@tools/wr-catalog-base'

import { OptionWrapper } from './styles'

const RenderOption = (props) => (
  <>
    <Checkbox
      type="checkbox"
      checked={props.isSelected}
      disabled={props.isSelected}
      checkedDisabledColor={context.theme.components.dropdownInput.selectedColor}
      onChange={() => null}
    />{' '}
    <label>{props.label}</label>
  </>
)

RenderOption.propTypes = {
  isSelected: propTypes.bool,
  label: propTypes.string,
}

export default class CategoriesDropdown extends Component {
  static propTypes = {
    context: propTypes.shape({
      state: propTypes.shape({
        categoryFilters: propTypes.array,
        categories: propTypes.array,
      }),
      actions: propTypes.shape({
        updateCategoryFilters: propTypes.func,
      }),
    }),
    filterByCategoryLabel: propTypes.string,
    categories: propTypes.array,
    orderCategoriesAZ: propTypes.bool,
    orderCategoriesZA: propTypes.bool,
  }

  static defaultProps = {
    filterByCategoryLabel: i18n('toolbar.filterByCategory'),
    orderCategoriesAZ: false,
    orderCategoriesZA: false,
  }

  constructor(props) {
    super(props)
    const { categoryFilters } = props.context.state
    const categories = this.props.categories || context.state.categories
    const selectedCategories = (categoryFilters || []).map((id) => categories.find((v) => v.id === id))
    this.state = {
      categoriesValue: [...selectedCategories],
    }
  }

  selectChildrenCategory = (selectOption, child) => {
    selectOption({ label: child.name, value: child.id, id: child.id, parentCategoryId: child.parentCategoryId })
  }

  selectMainCategory = (hasChildren, option, getValue, setValue) => {
    let newValue = getValue()

    newValue.push(option)

    if (hasChildren) {
      const childrens = context.state.categories.filter((categ) => categ.parentCategoryId === option.value)

      childrens.forEach((child) => {
        const valueExists = newValue.filter((val) => val.value === child.id)

        if (valueExists.length > 0) {
          const valueIndex = newValue.findIndex((val) => val.value === child.id)

          newValue = [
            ...newValue.slice(0, valueIndex),
            ...newValue.slice(valueIndex + 1),
            { label: child.name, value: child.id, id: child.id, parentCategoryId: child.parentCategoryId },
          ]
        } else {
          newValue.push({ label: child.name, value: child.id, id: child.id, parentCategoryId: child.parentCategoryId })
        }
      })

      setValue(newValue)
    }
  }

  Option = (props) => {
    const { data, getValue, setValue } = props
    const hasChildren = context.state.categories.filter((categ) => categ.parentCategoryId === data.value)
    const isChildren = data.parentCategoryId

    if (isChildren) return null

    return (
      <>
        <OptionWrapper
          isSelected={props.isSelected}
          onClick={() => this.selectMainCategory(hasChildren, data, getValue, setValue)}
          key={data.id}
        >
          <RenderOption {...props} />
        </OptionWrapper>
        {hasChildren.length > 0 && hasChildren.map((child) => this.renderOptionChildren({ child, props, padding: 20 }))}
      </>
    )
  }

  renderOptionChildren = ({ child, props, padding }) => {
    const categorySelection = context.state.categoryFilters
    const distance = padding + 20
    const isSelected = context.state.categoryFilters.includes(child.id)
    const hasChildren = context.state.categories.filter((categ) => categ.parentCategoryId === child.value)
    const isChildrenSelected = categorySelection.filter((categ) => categ === child.id).length > 0

    return (
      <>
        <OptionWrapper
          isSelected={isSelected}
          onClick={() => this.selectChildrenCategory(props.selectOption, child)}
          key={child.id}
          paddingLeft={`${distance}px`}
        >
          <RenderOption {...props} isSelected={isChildrenSelected} label={child.label} data={child} value={child.id} />
        </OptionWrapper>
        {hasChildren.length > 0 &&
          hasChildren.map((child, index) => this.renderOptionChildren({ child, isSelected, props, padding: distance }))}
      </>
    )
  }

  handleCategoriesChange = (categories) => {
    const { context } = this.props
    const { categoryFilters } = context.state

    if (!categories) {
      categories = []
    }

    const categoriesId = categories.map((c) => c.id)
    const thisCatIds = this.props.categories.map((c) => c.id)

    categoriesId
      .filter((c) => !categoryFilters.includes(c))
      .forEach((cat) => context.actions.updateCategoryFilters(cat))
    categoryFilters
      .filter((id) => {
        return !categoriesId.includes(id) && thisCatIds.includes(id)
      })
      .forEach((cat) => context.actions.updateCategoryFilters(cat))

    this.setState({ categoriesValue: categories })
  }

  render() {
    const { filterByCategoryLabel, context, styles } = this.props
    const categories = this.props.categories || context.state.categories
    const options = categories

    return (
      <DropDownInput
        data-test-id="categories-dropdown"
        value={this.state.categoriesValue}
        onChange={this.handleCategoriesChange}
        options={options}
        className="categories"
        classNamePrefix="categories"
        placeholder={filterByCategoryLabel}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{ Option: this.Option }}
        menuPortalTarget={document.body}
        isMulti
        large
        fullWidth
        styles={styles}
      />
    )
  }
}
